module.exports = __webpack_public_path__ + "static/img/logo-mini.510729d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-mini.png
// module id = 1415
// module chunks = 0